module.exports = __webpack_public_path__ + "asset/board-agenda-form--9359c5.png";